class ProductPreview {
  constructor() {
    this.triggers = [];
    this.init();
  }

  init() {
    this.findTriggers();
    this.bindEvents();
  }

  findTriggers() {
    this.triggers = document.querySelectorAll('[data-product-preview-trigger]');
    console.log('ProductPreview: Found', this.triggers.length, 'triggers');
  }

  bindEvents() {
    this.triggers.forEach(trigger => {
      // Remove existing event listeners to prevent duplicates
      trigger.removeEventListener('click', this.handleTriggerClick);
      trigger.addEventListener('click', this.handleTriggerClick.bind(this));
    });

    // Handle close button
    document.querySelectorAll('.preview-close').forEach(btn => {
      btn.removeEventListener('click', this.handleCloseClick);
      btn.addEventListener('click', this.handleCloseClick.bind(this));
    });

    // Handle add to cart
    document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
      btn.removeEventListener('click', this.handleAddToCart);
      btn.addEventListener('click', this.handleAddToCart.bind(this));
    });
    
    console.log('ProductPreview: Bound events to', this.triggers.length, 'triggers');
  }

  handleTriggerClick(e) {
    e.preventDefault();
    const handle = e.currentTarget.dataset.productHandle;
    const container = e.currentTarget.closest('[data-product-item]') || document;
    let popup = container.querySelector(`[data-preview-popup="${handle}"]`);
    if (!popup) {
      popup = document.querySelector(`[data-preview-popup="${handle}"]`);
    }
    
    console.log('ProductPreview: Trigger clicked for handle:', handle, 'popup found:', !!popup);
    
    if (popup) {
      // Show popup
      popup.style.setProperty('top', '0', 'important');
      popup.setAttribute('data-preview-open', 'true');

      // Scroll to popup
      popup.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } else {
      console.error('ProductPreview: Popup not found for handle:', handle);
    }
  }

  handleCloseClick(e) {
    e.preventDefault();
    const popup = e.currentTarget.closest('.product-preview-popup');
    if (popup) {
      popup.style.setProperty('top', '100%', 'important');
      popup.removeAttribute('data-preview-open');
    }
  }

  // Method to reinitialize for dynamic content
  reinit() {
    this.findTriggers();
    this.bindEvents();
  }

  async handleAddToCart(e) {
    e.preventDefault();
    const button = e.currentTarget;
    
    // Get the product ID and default variant ID
    const productId = button.dataset.productId;
    let variantId = button.dataset.defaultVariantId;

    // Check if there's a selected swatch
    const swatchContainer = button.closest('[data-product-item]')?.querySelector('[data-swatches-container]');
    if (swatchContainer) {
      const selectedSwatch = swatchContainer.querySelector('input[type="radio"]:checked');
      if (selectedSwatch) {
        // Get variant data from the swatch container
        const swatchDataElement = swatchContainer.closest('[data-swatches]')?.querySelector('[data-swatch-data]');
        if (swatchDataElement) {
          try {
            const swatchData = JSON.parse(swatchDataElement.textContent);
            const selectedValue = selectedSwatch.value;
            
            // Find the matching variant
            const matchingVariant = swatchData.variants.find(variant => 
              variant[swatchData.swatchOptionKey] === selectedValue
            );
            
            if (matchingVariant) {
              variantId = matchingVariant.id;
            }
          } catch (error) {
            console.error('Error parsing swatch data:', error);
          }
        }
      }
    }

    // Add to cart
    try {
      button.disabled = true;
      const data_atc_banner = $('[data-templates] [data-atc-banner]').clone();
      const money_format = $('[global-item-grid]').attr('money-format');
    
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { quantity: 1, id: variantId },
        dataType: 'json',
        success: function(res) {
          data_atc_banner.attr('data-animation-state','open');
          data_atc_banner.attr('tabindex','-1');

          const productImage = data_atc_banner.find('[data-atc-banner-product-image]');
          productImage.html(`<img src="${res.image}" alt="${res.product_title}">`);

          const productTitle = data_atc_banner.find('[data-atc-banner-product-title]');
          productTitle.html(res.title);
          
          const productPriceQuantity = data_atc_banner.find('[data-atc-banner-product-price-quantity]');
          productPriceQuantity.html(`${res.quantity} x `);
         

          const productPriceValue = data_atc_banner.find('[data-atc-banner-product-price-value]');
          
          productPriceValue.html((res.original_price / 100).toLocaleString("en-IN"));


          const productPriceDiscounted = data_atc_banner.find('[data-atc-banner-product-price-discounted]');

          if (res.final_price < res.original_price) {
              productPriceDiscounted.html($(res.final_price / 100).toLocaleString("en-IN"));
              productPriceDiscounted.removeClass('hidden');
              productPriceValue.addClass('original-price');
          } else {
              productPriceDiscounted.addClass('hidden');
              productPriceValue.removeClass('original-price');
          }
          
          const productDiscounts = data_atc_banner.find('[data-atc-banner-product-discounts]');
          productDiscounts.addClass('hidden');

          const subTotal = data_atc_banner.find('[data-atc-banner-cart-subtotal]');
          const itemCount = data_atc_banner.find('[data-atc-banner-cart-button] span');
          const countBubble = $('.site-header-cart--count');

          $.getJSON('/cart.js', function(cart) {
            subTotal.hide();
            itemCount.html(cart.item_count);
            countBubble.attr('data-header-cart-count', cart.item_count).addClass('visible');
          })

          $('[data-site-header] [data-message-banner]')?.remove();
          $('[data-site-header] [data-atc-banner]')?.remove();
          $('[data-site-header]').append(data_atc_banner);
        },
        error: function() {
          errorMessage('product');
        }
    });

    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      button.disabled = false;
    }
}
 }

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  window.productPreview = new ProductPreview();
  
  // Fallback: reinitialize after a short delay to catch any late-loaded content
  setTimeout(() => {
    if (window.productPreview) {
      window.productPreview.reinit();
    }
  }, 1000);
});

// Reinitialize when new content is loaded (for dynamic content)
document.addEventListener('shopify:section:load', () => {
  if (window.productPreview) {
    window.productPreview.reinit();
  }
});

// Reinitialize for product recommendations
document.addEventListener('productRecommendationsLoaded', () => {
  if (window.productPreview) {
    window.productPreview.reinit();
  }
});

// Fallback: reinitialize periodically for dynamic content
setInterval(() => {
  if (window.productPreview) {
    const triggers = document.querySelectorAll('[data-product-preview-trigger]');
    const currentTriggers = window.productPreview.triggers;
    
    // If we find new triggers that aren't bound, reinitialize
    if (triggers.length !== currentTriggers.length) {
      window.productPreview.reinit();
    }
  }
}, 2000);

// Global method for manual reinitialization (for testing)
window.reinitProductPreview = () => {
  if (window.productPreview) {
    window.productPreview.reinit();
    console.log('ProductPreview: Manually reinitialized');
  } else {
    console.log('ProductPreview: Instance not found');
  }
}; 